import thumbnail1 from "./../images/image-product-1-thumbnail.jpg";
import thumbnail2 from "./../images/image-product-2-thumbnail.jpg";
import thumbnail3 from "./../images/image-product-3-thumbnail.jpg";
import thumbnail4 from "./../images/image-product-4-thumbnail.jpg";
import img1 from "./../images/image-product-1.jpg";
import img2 from "./../images/image-product-2.jpg";
import img3 from "./../images/image-product-3.jpg";
import img4 from "./../images/image-product-4.jpg";

const images = [
  {
    id: 1,
    thumbnail: thumbnail1,
    img: img1,
  },
  {
    id: 2,
    thumbnail: thumbnail2,
    img: img2,
  },
  {
    id: 3,
    thumbnail: thumbnail3,
    img: img3,
  },
  {
    id: 4,
    thumbnail: thumbnail4,
    img: img4,
  },
];

export default images;
